// extracted by mini-css-extract-plugin
export default {"site":"day_site__ISLQF","homeLink":"day_homeLink__ek76g","myButton":"day_myButton__7tPSb"};